// Wrap everything in an IIFE to avoid global scope pollution
(function() {
    // Cache DOM elements at module level
    let jsonLoader;
    let jsonFabricContainer;
    let fallbackContainer;
    let fabricInput;
    let selectedValueSpan;
    let selectedFabricDiv;
    let fabSpan;
    let fabSpanTitle;
    
    document.addEventListener('DOMContentLoaded', function() {
        // Initialize DOM elements
        jsonLoader = document.getElementById('json-loader');
        jsonFabricContainer = document.getElementById('json-fabric-container');
        fallbackContainer = document.getElementById('fallback-fabric-container');
        
        // Tab elements
        fabricInput = document.getElementById('selfabric');
        selectedValueSpan = document.querySelector('.selectd__upholstery__value');
        selectedFabricDiv = document.querySelector('.selected__fabric');
        fabSpan = document.querySelector('.fab-span');
        fabSpanTitle = document.querySelector('.fab-span-title');
    
    // Setup upholstery inputs on page load
    function setupUpholsteryInputs() {
        // Clear default values
        if (fabricInput && fabricInput.value === 'View Below') {
            fabricInput.value = '';
        }
        
        const mainUpholsteryInput = document.querySelector('input[name="properties[Upholstery]"]');
        if (mainUpholsteryInput && mainUpholsteryInput.value === 'View Below') {
            mainUpholsteryInput.value = '';
        }
    }
    
    // Call setup immediately
    setupUpholsteryInputs();
    
    // Load metaobject data and start processing
    async function loadData() {
        if (!jsonLoader) {
            return;
        }

        const variantsData = jsonLoader.dataset.productVariants;
        let variants = [];
        try {
            variants = variantsData ? JSON.parse(variantsData) : [];
        } catch (e) {
            variants = [];
        }

        const productHandle = jsonLoader.dataset.productHandle;
        const productVendor = jsonLoader.dataset.productVendor;

        try {
            if (!window.UpholsteryMetaobject) {
                throw new Error('UpholsteryMetaobject loader is not available');
            }

            const resolved = window.UpholsteryMetaobject.resolveMetaobjectFabricData(jsonLoader);

            if (resolved.useFallback) {
                if (fallbackContainer) {
                    fallbackContainer.style.display = 'block';
                }
                return;
            }

            const hasMatches = await processVariants(
                resolved.groupData,
                resolved.categoryData,
                variants,
                productVendor,
                productHandle
            );

            if (!hasMatches && fallbackContainer) {
                fallbackContainer.style.display = 'block';
            }
        } catch (error) {
            if (fallbackContainer) {
                fallbackContainer.style.display = 'block';
            }
        }
    }
    
    // Process variants and create fabric blocks
    async function processVariants(groupData, categoryData, variants, productVendor, productHandle) {
        // Clear container
        jsonFabricContainer.innerHTML = '';
        
        // Ensure variants is an array
        if (!Array.isArray(variants)) {
            return false;
        }
        
        // Filter out _COM, Optional, and Quick Ship (-qs)
        // But KEEP Featured (*) variants since they seem to be the ones we want to process
        const processableVariants = variants.filter(v => {
            if (!v || typeof v !== 'string') return false;
            const handleized = v.toLowerCase().replace(/\s+/g, '-');
            return v !== '_COM' && 
                   v !== 'Optional' && 
                   !handleized.includes('-qs');
        });
        
        // Check if we should use upholstery group strategy
        let upholsteryGroupData = null;
        if (categoryData) {
            upholsteryGroupData = findApplicableGroups(categoryData, productVendor, productHandle);
        }
        
        // Track if we found any matches
        let hasAnyMatches = false;
        const renderedGroups = new Set(); // Track what we've already rendered

        if (!categoryData && Array.isArray(groupData) && groupData.length > 0) {
            if (isFinishSwatchMode()) {
                renderFinishSwatchesMode(groupData);
            } else {
                groupData.forEach(fabric => {
                    createFabricGroupBlock(fabric);
                });
            }
            hasAnyMatches = true;
        } else {
        for (const variant of processableVariants) {
            // Skip if already rendered (for grouped fabrics)
            if (renderedGroups.has(variant)) continue;
            
            // Try upholstery group lookup first
            if (upholsteryGroupData && upholsteryGroupData.applicableGroups) {
                const groupMatches = findAllVariantsInGroup(variant, upholsteryGroupData.applicableGroups, groupData);
                if (groupMatches && groupMatches.length > 0) {
                    // Render all fabrics in this group
                    groupMatches.forEach(match => {
                        createFabricGroupBlock(match);
                    });
                    renderedGroups.add(variant);
                    hasAnyMatches = true;
                    continue;
                }
            }
            
            // Try direct upholstery lookup
            const directMatch = findFabricByName(variant, groupData);
            if (directMatch) {
                createFabricGroupBlock(directMatch);
                renderedGroups.add(variant);
                hasAnyMatches = true;
                continue;
            }
        }
        }
        
        // Initialize event listeners if we have matches
        if (hasAnyMatches) {
            setTimeout(attachEventListeners, 100);
        }
        
        return hasAnyMatches;
    }
    
    // Find applicable groups for vendor/product
    function findApplicableGroups(categoryData, productVendor, productHandle) {
        let applicableGroups = {};
        let isSpecificMatch = false;
        
        const vendorData = categoryData[productVendor];
        if (!vendorData || !vendorData.products) {
            return { applicableGroups, isSpecificMatch };
        }
        
        const products = vendorData.products;
        
        // Check for specific product matches
        for (const handlePattern in products) {
            if (handlePattern === 'all_products' || handlePattern === 'all products') continue;
            
            const patterns = handlePattern.split(',').map(p => p.trim());
            if (patterns.some(pattern => productHandle.includes(pattern))) {
                applicableGroups = products[handlePattern].groups || {};
                isSpecificMatch = true;
                break;
            }
        }
        
        // Fallback to all_products
        if (!isSpecificMatch) {
            if (products.all_products) {
                applicableGroups = products.all_products.groups || {};
            } else if (products['all products']) {
                applicableGroups = products['all products'].groups || {};
            }
        }
        
        return { applicableGroups, isSpecificMatch };
    }
    
    // Find ALL variants in a group
    function findAllVariantsInGroup(variant, applicableGroups, groupData) {
        const matches = [];
        
        // Check each category
        for (const categoryName in applicableGroups) {
            if (categoryName === variant) {
                // Find all fabrics in this category
                const includes = applicableGroups[categoryName].includes || [];
                for (const fabricId of includes) {
                    const fabric = groupData.find(g => g.Upholstery_Variant === fabricId);
                    if (fabric) {
                        matches.push({ ...fabric, categoryName });
                    }
                }
                break; // We found the matching category, no need to continue
            }
        }
        
        return matches;
    }
    
    // Find fabric by direct name match (Shopify option may equal Display_Name, not Variant Key)
    function findFabricByName(name, fabricGroups) {
        const nameLower = name.toLowerCase();
        
        return fabricGroups.find(fabric => {
            if (!fabric.Swatches || fabric.Swatches.length === 0) return false;
            const candidates = [
                fabric.optionValue,
                fabric.Display_Name,
                fabric.Upholstery_Variant
            ].filter(Boolean).map(v => String(v).toLowerCase());
            return candidates.indexOf(nameLower) !== -1;
        });
    }
    
    // Create a fabric group block (from JSON data)
    function isFinishSwatchMode() {
        return jsonLoader && jsonLoader.dataset.finishSwatchMode === 'true';
    }

    function renderFinishSwatchesMode(groupData) {
        const containerDiv = document.createElement('div');
        containerDiv.className = 'product-swatches-alt finish-color-swatches scroll-swatches';

        const ul = document.createElement('ul');
        ul.id = 'variant';
        ul.className = 'clear';

        (groupData || []).forEach(fabricData => {
            if (!fabricData || !fabricData.Swatches || fabricData.Swatches.length === 0) return;

            const swatch = fabricData.Swatches[0];
            const colorName = fabricData.Upholstery_Variant || fabricData.Display_Name || swatch.Web_Name;
            if (!colorName) return;

            let imageUrl = swatch.Link_Handle || '';
            if (!imageUrl) return;

            const s3Base = (jsonLoader && jsonLoader.dataset.s3Url) || 'https://designpublic-api-hni.s3.us-west-1.amazonaws.com';
            if (imageUrl.startsWith('/')) {
                imageUrl = `${s3Base}${imageUrl}`;
            }

            const handleName = colorName.toLowerCase().replace(/\s+/g, '-');

            const li = document.createElement('li');
            li.className = 'variant';

            const anchor = document.createElement('a');
            anchor.href = '#';
            anchor.title = colorName;
            anchor.setAttribute('rel', 'nofollow');
            anchor.style.backgroundImage = `url(${imageUrl})`;

            const img = document.createElement('img');
            img.setAttribute('data-src', imageUrl);
            img.name = handleName;
            img.alt = colorName;
            img.title = colorName;

            const span = document.createElement('span');
            span.textContent = colorName;

            anchor.appendChild(img);
            li.appendChild(anchor);
            li.appendChild(span);
            ul.appendChild(li);
        });

        if (!ul.children.length) return;

        containerDiv.appendChild(ul);
        jsonFabricContainer.appendChild(containerDiv);

        if (typeof lazyLoadImage === 'function') {
            lazyLoadImage({
                selector: '.finish-color-swatches .variant a',
                wrapper: '.finish-color-swatches',
                callback: (ele) => {
                    const imgEl = ele.querySelector('img');
                    if (!imgEl) return;
                    const src = imgEl.getAttribute('data-src') || imgEl.getAttribute('src');
                    if (src) {
                        imgEl.setAttribute('src', src);
                        ele.style.backgroundImage = `url(${src})`;
                    }
                }
            });
        } else {
            lazyLoadImages(ul);
        }
    }

    function createFabricGroupBlock(fabricData) {
        if (!fabricData.Swatches || fabricData.Swatches.length === 0) return;
        
        // Create container div
        const containerDiv = document.createElement('div');
        containerDiv.id = 'option-variants';
        
        // Add title
        const title = document.createElement('h4');
        title.textContent = fabricData.Display_Name || fabricData.Upholstery_Variant;
        containerDiv.appendChild(title);
        
        // Add composition/durability info
        if (fabricData.Composition) {
            const comp = document.createElement('p');
            comp.innerHTML = `Composition: ${decodeHTMLEntities(fabricData.Composition)}`;
            containerDiv.appendChild(comp);
        }
        
        if (fabricData.Durability) {
            const dur = document.createElement('p');
            dur.innerHTML = `Durability: ${decodeHTMLEntities(fabricData.Durability)}`;
            containerDiv.appendChild(dur);
        }
        
        // Create swatch list
        const ul = document.createElement('ul');
        ul.id = 'variant';
        ul.className = 'clear';
        
        // Shopify option / PDP selected label must use Display Name (or option_value),
        // NOT Variant Key (e.g. "Remix 3 Fabric" not "Midj Remix 3 Fabric").
        // Variant Key stays available as data-variant-key for lookups only.
        const variantKey = fabricData.Upholstery_Variant || '';
        const shopifyOptionValue = (
            fabricData.optionValue ||
            fabricData.Display_Name ||
            variantKey
        ).trim();
        
        // Add swatches
        fabricData.Swatches.forEach(swatch => {
            const li = document.createElement('li');
            li.className = 'variant';
            
            const imageUrl = swatch.Link_Handle.startsWith('/') ?
                `https://designpublic-api-hni.s3.us-west-1.amazonaws.com${swatch.Link_Handle}` :
                swatch.Link_Handle;
            
            // Create the anchor with proper data attributes
            const anchor = document.createElement('a');
            anchor.href = '#';
            anchor.title = shopifyOptionValue;
            anchor.setAttribute('data-group', shopifyOptionValue);
            anchor.setAttribute('data-variant-key', variantKey);
            anchor.setAttribute('data-fabric-type', shopifyOptionValue);
            anchor.setAttribute('data-fabric-code', swatch.Web_Name);
            anchor.setAttribute('data-fabric-category', fabricData.categoryName || '');
            
            const img = document.createElement('img');
            img.id = 'varfabric';
            img.setAttribute('data-src', imageUrl);
            img.title = swatch.Web_Name;
            img.name = `${fabricData.Upholstery_Variant.toLowerCase().replace(/\s+/g, '-')}-${swatch.Web_Name.toLowerCase().replace(/\s+/g, '-')}`;
            img.alt = swatch.Web_Name;
            
            anchor.appendChild(img);
            
            const span = document.createElement('span');
            span.textContent = swatch.Web_Name;
            
            li.appendChild(anchor);
            li.appendChild(span);
            
            ul.appendChild(li);
        });
        
        containerDiv.appendChild(ul);
        jsonFabricContainer.appendChild(containerDiv);
        
        // Lazy load images
        lazyLoadImages(ul);
    }
    
    // Decode HTML entities
    function decodeHTMLEntities(text) {
        if (!text) return '';
        const textArea = document.createElement('textarea');
        textArea.innerHTML = text;
        return textArea.value;
    }
    
    // Lazy load images
    function lazyLoadImages(container) {
        const images = container.querySelectorAll('img[data-src]');
        images.forEach(img => {
            // Simple lazy loading
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
        });
    }
    
    // Attach event listeners
    function attachEventListeners() {
        // Handle fabric clicks - integrate with existing clickVariantImage function
        document.querySelectorAll('#json-fabric-container a').forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                
                // Store current scroll position
                const currentScrollY = window.scrollY;
                
                // Get the category name and fabric details
                const categoryName = link.getAttribute('data-fabric-category');
                const fabricType = link.getAttribute('data-fabric-type');
                const fabricCode = link.getAttribute('data-fabric-code');
                
                // For group matches, we need to set the title to the category name
                if (categoryName) {
                    // Temporarily update the title attribute to use the group name
                    const originalTitle = link.getAttribute('title');
                    link.setAttribute('title', categoryName);
                    
                    // Call the existing clickVariantImage function
                    if (typeof clickVariantImage === 'function') {
                        clickVariantImage(this);
                        
                        // Restore original title
                        link.setAttribute('title', originalTitle);
                        
                        // Update the selfabric input AFTER clickVariantImage runs
                        setTimeout(() => {
                            if (fabricInput) {
                                fabricInput.value = `${fabricType} ${fabricCode}`;
                            }
                        }, 50);
                    } else {
                        // Fallback if function doesn't exist
                        handleFabricClick(e);
                    }
                } else {
                    // For direct matches, use as is
                    if (typeof clickVariantImage === 'function') {
                        clickVariantImage(this);
                    } else {
                        // Fallback if function doesn't exist
                        handleFabricClick(e);
                    }
                }
                
                // Restore scroll position after a small delay to counteract the scrollToElement
                setTimeout(() => {
                    window.scrollTo(0, currentScrollY);
                }, 10);
            });
        });
    }
    
    // Fallback fabric selection handler (only used if clickVariantImage doesn't exist)
    function handleFabricClick(e) {
        e.preventDefault();
        
        const link = e.currentTarget;
        const img = link.querySelector('img');
        if (!img) return;
        
        const groupName = link.getAttribute('title') || link.getAttribute('data-group');
        const fabricType = link.getAttribute('data-fabric-type') || groupName;
        const fabricCode = link.getAttribute('data-fabric-code') || img.getAttribute('title');
        const categoryName = link.getAttribute('data-fabric-category') || '';
        
        // Update the UI using the same selectors as scripts.js
        const fabric = document.querySelector('.fabric');
        if (fabric) {
            // Update preview image
            const fabSpan = fabric.querySelector('.fab-span');
            if (fabSpan) {
                fabSpan.style.backgroundImage = `url(${img.src})`;
                fabSpan.classList.remove('__no__image');
            }
            
            // Update title
            const fabSpanTitle = fabric.querySelector('.fab-span-title');
            if (fabSpanTitle) {
                fabSpanTitle.innerHTML = fabricCode;
            }
            
            // Show the preview
            const selectedFabric = fabric.closest('.selected__fabric');
            if (selectedFabric) {
                selectedFabric.classList.remove('hidden');
            }
        }
        
        // Update inputs
        if (fabricInput) {
            fabricInput.value = categoryName ? `${fabricType} ${fabricCode}` : fabricCode;
        }
        
        // Update the swatch input
        const fabSwatch = document.getElementById('fabSwatch') || document.querySelector('input[name="properties[_Swatch]"]');
        if (fabSwatch) {
            fabSwatch.value = img.src;
        }
        
        // Update the display value
        const upholsteryTab = document.querySelector('.upholstery__tab');
        if (upholsteryTab) {
            upholsteryTab.classList.add('__selected');
            
            const selectedValueSpan = upholsteryTab.querySelector('.selectd__upholstery__value');
            if (selectedValueSpan) {
                selectedValueSpan.textContent = categoryName || groupName;
            }
        }
        
        // Update the dynamic option property input
        const optionName = jsonLoader.dataset.optionName || 'Upholstery';
        const dynamicPropertyName = `properties[${optionName}]`;
        let optionInput = document.querySelector(`input[name="${dynamicPropertyName}"]`);
        
        if (optionInput) {
            optionInput.value = categoryName || fabricType;
        } else {
            // Create it if it doesn't exist
            const form = document.querySelector('form[action*="/cart/add"]');
            if (form) {
                const newInput = document.createElement('input');
                newInput.type = 'hidden';
                newInput.name = dynamicPropertyName;
                newInput.value = categoryName || fabricType;
                form.appendChild(newInput);
            }
        }
        
        // Show add to cart button
        const addToCart = document.querySelector('.addtocart');
        const addToCartDefault = document.querySelector('.addtocartDefault');
        if (addToCart && addToCartDefault) {
            addToCart.classList.remove('hidden');
            addToCart.style.display = '';
            addToCartDefault.classList.add('hidden');
            addToCartDefault.style.display = 'none';
        }
        
        // Remove existing selected classes
        document.querySelectorAll('.variant.selected').forEach(v => {
            v.classList.remove('selected');
        });
        document.querySelectorAll('.variant a.select').forEach(a => {
            a.classList.remove('select');
        });
        
        // Add selected class
        link.parentElement.classList.add('selected');
        link.classList.add('__loaded', 'select');
        
        // Update Shopify variant
        updateShopifyVariant(categoryName || groupName);
    }
    
    // Update Shopify variant selection
    function updateShopifyVariant(variantToFind) {
        // Get selected values from other options
        let selectedValues = '';
        if (typeof getSelectedVariantValues === 'function') {
            selectedValues = getSelectedVariantValues('selectd__variant__value', true);
        }
        
        // Build full variant title
        let fullVariantTitle = variantToFind;
        if (selectedValues) {
            fullVariantTitle = variantToFind + ' / ' + selectedValues;
        }
        
        // Find matching variant
        if (typeof product_json !== 'undefined' && product_json.variants) {
            const matchingVariant = product_json.variants.find(v => {
                return v.title === fullVariantTitle || 
                       v.option1 === variantToFind ||
                       v.option2 === variantToFind ||
                       v.option3 === variantToFind;
            });
            
            if (matchingVariant) {
                const productSelect = document.getElementById('productSelect');
                if (productSelect) {
                    productSelect.value = matchingVariant.id;
                    
                    // Trigger change event
                    if (typeof triggerEvent === 'function') {
                        triggerEvent(productSelect, 'change');
                    } else {
                        productSelect.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
            }
        }
    }
    
    // Override the showHideVariantsOptions function to preserve our swatches
    const originalShowHideVariantsOptions = window.showHideVariantsOptions;
    window.showHideVariantsOptions = function(filter_variants) {
        // Store current fabric selection
        const selectedFabric = document.querySelector('#json-fabric-container .variant a.select');
        const fabricValue = fabricInput ? fabricInput.value : '';
        
        // Call original function if it exists
        if (typeof originalShowHideVariantsOptions === 'function') {
            originalShowHideVariantsOptions(filter_variants);
        }
        
        // ALWAYS show our JSON-loaded fabric swatches
        document.querySelectorAll('#json-fabric-container .variant').forEach(variant => {
            variant.classList.remove('hide');
            variant.classList.add('shown');
            variant.style.display = ''; // Force display
        });
        
        // Also ensure the option-variants containers are visible
        document.querySelectorAll('#json-fabric-container #option-variants').forEach(container => {
            container.classList.remove('hide');
            container.style.display = ''; // Force display
        });
        
        // Restore selection if it was cleared
        if (selectedFabric && !selectedFabric.classList.contains('select')) {
            selectedFabric.classList.add('select');
            if (fabricInput && fabricValue) {
                fabricInput.value = fabricValue;
            }
        }
    };
    
    // Also monitor for any other attempts to hide our swatches
    function protectJsonSwatches() {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && 
                    (mutation.attributeName === 'class' || mutation.attributeName === 'style')) {
                    const element = mutation.target;
                    
                    // Check if it's one of our JSON swatches being hidden
                    if (element.closest('#json-fabric-container') && 
                        (element.classList.contains('hide') || element.style.display === 'none')) {
                        element.classList.remove('hide');
                        element.classList.add('shown');
                        element.style.display = '';
                    }
                }
            });
        });
        
        // Observe all elements in the JSON fabric container
        const container = document.getElementById('json-fabric-container');
        if (container) {
            observer.observe(container, {
                attributes: true,
                attributeFilter: ['class', 'style'],
                subtree: true
            });
        }
    }
    
    // Start protection after a delay to ensure DOM is ready
    setTimeout(protectJsonSwatches, 500);
    
    // Start loading data
    loadData();
});
})();